import {useCallback} from 'react';

import type {MouseEvent} from 'react';

/** A native tooltip with the full `text`, set on hover only while the element is cut off (wide or clamped to lines). */
export function useOverflowTitle<T extends HTMLElement>(text: string) {
  const onMouseEnter = useCallback(
    ({currentTarget}: MouseEvent<T>) => {
      const isCutOff =
        currentTarget.scrollWidth > currentTarget.clientWidth ||
        currentTarget.scrollHeight > currentTarget.clientHeight;
      if (isCutOff) currentTarget.title = text;
      else currentTarget.removeAttribute('title');
    },
    [text]
  );

  return {onMouseEnter};
}
